import React from "react";
import { useQuery } from "@apollo/client";
import { MOBILE_BANNER } from "../../gqlOperations/queries";
import useStyles from "./styles";
import MobAtHomeLoader from "../skeletonLoader/MobAtHomeLoader";

export default function MobileRegisterBanner() {
  const classes = useStyles();
  const { loading, error, data } = useQuery(MOBILE_BANNER);
  const imgData = data?.mobileBanners.data.map(
    (detail, idx) => detail.attributes.imageURL
  );

  return (
    <>
      <div className={classes.homeBannerCard}>
        {loading ? (
          <MobAtHomeLoader />
        ) : (
          <a
            target="blank"
            href="https://www.khelomore.com/sports-coaching/society-sports-coaching"
          >
            <img
              className={classes.homeBanner}
              src="https://km-landing.s3.ap-south-1.amazonaws.com/Images/km-homePageNew/mobRsBanner.png"
              alt="home-banner"
            />
          </a>
        )}
      </div>
    </>
  );
}
